import React from 'react';
import PropTypes from 'prop-types';
import { LoadScript, GoogleMap, Marker } from '@react-google-maps/api';
import getEnvItem from '../data/env/env-helpers';

const MyGoogleMap = (props) => {
  const {
    lat,
    lng,
    centerLat,
    centerLng,
    onLoadMap,
    onLoadError,
    onChangeMarker,
    markerLabel,
    disabled,
  } = props;

  const apiKey = getEnvItem('REACT_APP_GOOGLE_MAP_API_KEY', 'string');

  return (
    <LoadScript
      id="script-loader"
      onError={onLoadError}
      googleMapsApiKey={apiKey}
    >
      <GoogleMap
        onLoad={onLoadMap}
        mapContainerStyle={{ height: 300 }}
        center={{
          lat: centerLat,
          lng: centerLng,
        }}
        zoom={15}
        id="map"
      >
        <Marker
          position={{
            lat,
            lng,
          }}
          title={markerLabel || 'My Location'}
          draggable={!disabled}
          onDragEnd={onChangeMarker}
        />
      </GoogleMap>
    </LoadScript>
  );
};

MyGoogleMap.propTypes = {
  lat: PropTypes.number,
  lng: PropTypes.number,
  centerLat: PropTypes.number,
  centerLng: PropTypes.number,
  onLoadMap: PropTypes.func,
  onLoadError: PropTypes.func,
  onChangeMarker: PropTypes.func,
  markerLabel: PropTypes.string,
  disabled: PropTypes.bool,
};

MyGoogleMap.defaultProps = {
  lat: 0,
  lng: 0,
  centerLat: 0,
  centerLng: 0,
  onLoadMap: undefined,
  onLoadError: undefined,
  onChangeMarker: undefined,
  markerLabel: undefined,
  disabled: false,
};

export default MyGoogleMap;
